import { fg } from '@atlaskit/platform-feature-flags';

export const isHoverCardFixFgEnabled = () => {
	return (
		// eslint-disable-next-line @atlaskit/platform/no-preconditioning
		fg('qf_hover_card_fix') && fg('hover-card-prop-should-render-to-parent')
	);
};
